import { Action, handleActions } from 'redux-actions'
import {
  Gender,
  Lang,
  OnboardingStatus,
  Role,
  ServiceProvider,
  Units,
  UserCompanyDto,
  UserCompanyRolesDto,
  UserProfileDto,
  WhoAmI$Response,
} from '../../services/api.types'
import { getWhoAmISuccess, setOnboardingStatusProfileData, updateCompanyBrandLogo, updateLastSync } from './authActions'

const userDtoDefault: UserProfileDto = {
  active: true,
  createdAt: 0,
  dateOfBirth: '',
  country: '',
  email: '',
  firstName: '',
  gender: Gender.MALE,
  height: 0,
  lang: Lang.EN,
  lastName: '',
  onboardingStatus: OnboardingStatus.DONE,
  //onboardingStatus: OnboardingStatus.PROFILE_DATA,
  //role: Role.ANONYMOUS,
  userId: '',
  serviceProvider: ServiceProvider.YUMUUV, //ServiceProvider.GOOGLE_FIT,
  weight: 0,
  lastSync: 0,
  googleId: '',
  timeZone: '',
  units: Units.METRIC,
  appleId: '',
  integrationError: '',
  newsletterSubscriber: false,
  passwordSet: false,
  unreadNotificationsCount: 0,
  allowManualEntry: false,
}

class State {
  authenticated = false
  resetPasswordInProgress = false
  emailVerificationInProgress = false
  userDto: UserProfileDto = userDtoDefault
  userCompanies: UserCompanyDto[] = []
  userCompanyRoles: UserCompanyRolesDto[] = []
  managedCompanies: UserCompanyDto[] = []
  userIntegrationScopes = ''
  isSuperAdmin = false
}

export const auth = handleActions<State, WhoAmI$Response>(
  {
    [String(getWhoAmISuccess)]: (
      state: State,
      {
        payload: {
          authenticated,
          resetPasswordInProgress,
          emailVerificationInProgress,
          userDto,
          userCompanies,
          userCompanyRoles,
          userIntegrationScopes,
        },
      }: Action<any>,
    ): State => ({
      ...state,
      authenticated,
      resetPasswordInProgress,
      emailVerificationInProgress: !!emailVerificationInProgress,
      userIntegrationScopes,
      userDto: userDto || userDtoDefault,
      userCompanies: userCompanies || [],
      userCompanyRoles: userCompanyRoles || [],
      managedCompanies:
        (userCompanies &&
          userCompanyRoles &&
          userCompanies.filter((userCompany: UserCompanyDto) =>
            userCompanyRoles.some(
              (companyRole: { companyId: string; roles: any[] }) =>
                companyRole.companyId === userCompany.companyId &&
                companyRole.roles.some((role) => role === Role.ADMIN),
            ),
          )) ||
        [],
      isSuperAdmin:
        userCompanyRoles?.some((cr: UserCompanyRolesDto) => cr.roles.some((role) => role === Role.SUPER_ADMIN)) ||
        false,
    }),
    [String(setOnboardingStatusProfileData)]: (state: State): State => ({
      ...state,
      userDto: {
        ...state.userDto,
        onboardingStatus: OnboardingStatus.PROFILE_DATA,
        serviceProvider: ServiceProvider.APPLE_HEALTH,
      },
    }),
    [String(updateLastSync)]: (state: State): State => ({
      ...state,
      userDto: {
        ...state.userDto,
        lastSync: new Date().getTime(),
      },
    }),
    [String(updateCompanyBrandLogo)]: (state: State, { payload: { companyId, brandLogoUrl } }: Action<any>): State => ({
      ...state,
      userCompanies: state.userCompanies.map((uc) => (uc.companyId === companyId ? { ...uc, brandLogoUrl } : uc)),
      managedCompanies: state.managedCompanies.map((uc) => (uc.companyId === companyId ? { ...uc, brandLogoUrl } : uc)),
    }),
  },
  new State(),
)

export { State as AuthState }
